export default __webpack_public_path__ + "locales/hy-AM/Notifications.json?hash=1bd9f769e6e019b511d8318944904990";